<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{color}}-6">
						<h4 class="card-title"><i class="material-icons" (click)="back()">arrow_left</i> Brand Report
						</h4>
						<p class="card-category text-right">Brand</p>
					</div>
					<div class="card-body">
						<form class="navbar-form">
							<div class="row">

								<div class="col-4">
									<mat-form-field appearance="outline">
										<mat-label>Transaction Dates</mat-label>
										<mat-date-range-input [rangePicker]="picker">
											<input matStartDate [formControl]="fromdateCtrl" placeholder="Start date">
											<input matEndDate [formControl]="todateCtrl" placeholder="End date">
										</mat-date-range-input>
										<mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
										<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
										<mat-date-range-picker #picker></mat-date-range-picker>
									</mat-form-field>
								</div>

								<div class="col-4">
									<mat-form-field appearance="outline">
										<mat-label>Brands</mat-label>
										<mat-select [formControl]="brandRef" multiple #brandFilter>
											<div class="select-all" (click)="selectAllToggle('branch')">
												<button mat-icon-button>
													<div ml="1">Select All/None</div>
												</button>
											</div>
											<mat-option *ngFor="let k of brands" [value]="k.manufacturer_id">{{k.name}}</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								
								<div class="col-4">
									<mat-form-field appearance="outline">
										<mat-label>Branches</mat-label>
										<mat-select [formControl]="branchRef" multiple #branchFilter>
											<div class="select-all" (click)="selectAllToggle('branch')">
												<button mat-icon-button>
													<div ml="1">Select All/None</div>
												</button>
											</div>
											<mat-option *ngFor="let k of branches" [value]="k.loccode">{{k.locationname}}</mat-option>
										</mat-select>
									</mat-form-field>
								</div>

								<div class="col-4">
									<mat-form-field appearance="outline">
										<mat-label>Salespeople</mat-label>
										<mat-select [formControl]="salespersonRef" multiple #salesFilter>
											<div class="select-all" (click)="selectAllToggle('salesman')">
												<button mat-icon-button>
													<div ml="1">Select All/None</div>
												</button>
											</div>
											<mat-option *ngFor="let k of salespeople" [value]="k.salesmancode">{{k.salesmanname}}</mat-option>
										</mat-select>
									</mat-form-field>
								</div>

								<div class="col-4">
									<mat-form-field appearance="outline">
										<mat-label>Break out Product Lines?</mat-label>
										<mat-select [formControl]="conBrRef">
											<mat-option *ngFor="let v of conbr" [value]="v.value">
												{{v.label}}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</div>

								<div class="col-4">
									<button mat-raised-button color="white" type="submit" (click)="getBrandReport()">
										<mat-icon class="p-0">search</mat-icon> Search
									</button>
									<span *ngIf="sending">
										<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
											<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
										</svg>
									</span>
									&nbsp;&nbsp;
									<button class="btn btn-success btn-sm" (click)="$event.preventDefault();exportXls()" *ngIf="orderResults"> <i class="fa fa-file-excel-o"></i> XLS </button>
									&nbsp;&nbsp;
									<button class="btn btn-danger btn-sm" (click)="$event.preventDefault();exportPdf()" *ngIf="orderResults"> <i class="fa fa-file-pdf-o"></i> PDF </button>
								</div>
							</div>

						</form>

						<div *ngIf="orderResults">
							&nbsp;&nbsp; <button class="btn btn-success btn-sm" (click)="$event.preventDefault();exportXls()" *ngIf="orderResults">
								<i class="fa fa-file-excel-o"></i> XLS
							</button>
							&nbsp;&nbsp;
							<button class="btn btn-danger btn-sm" (click)="$event.preventDefault();exportPdf()" *ngIf="orderResults">
								<i class="fa fa-file-pdf-o"></i> PDF
							</button>

							<h3> Brand Sales Report {{reportCriteria.fromdate | date:'MM/d/yy'}} - {{reportCriteria.todate | date: 'MM/d/yy'}}</h3>
							<h4>
								{{getSubTitle()}}
							</h4>
						</div>

						<div *ngIf="orderResults">

							<h5>Count: {{ orderResults.totalqty }}</h5>
							<h5>Total: {{ orderResults.total | currency }}</h5>
							<ng-container *ngFor="let brandGroup of orderResults.lines | keyvalue">
								<ng-container *ngFor="let brand of brandGroup.value | keyvalue">
									
									<div class="card mb-3">
										<div class="card-header">
											Brand: {{ brand.key }}
										</div>
										<div class="card-body">
											<table class="table">
												<tr>
													<th>Brand</th>
													<th>Product Line</th>
													<th>Salesperson</th>
													<th>Location</th>
													<th>Qty</th>
													<th>Sales</th>
												</tr>
												<ng-container *ngFor="let line of brand.value.lines">
													<tr>
														<td>{{ line.Name }}</td>
														<td>{{ line.prodline }}</td>
														<td>{{ line.salesman }}</td>
														<td>{{ line.BR }}</td>
														<td>{{ line.SalesQty }}</td>
														<td>{{ line.Sales | currency }}</td>
													</tr>
												</ng-container>
											</table>
											<div class="card-footer text-muted">
												{{ brand.key }} Total: {{ brand.value.total | currency }} &nbsp; Count: {{brand.value.totalqty}}
											</div>
										</div>
									</div>
								</ng-container>
							</ng-container>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>